// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";

function isBidCapReached(bidCap, bidAsk, latestBid) {
  if (bidCap === undefined) {
    return false;
  }
  if (bidCap.isCapReached) {
    return true;
  }
  var myBidOnLot = Belt_Option.mapWithDefault(latestBid, 0, (function (x) {
          return Caml_format.int_of_string(x.amount.amount);
        }));
  var match = Belt_Option.map(latestBid, (function (x) {
          return x.bidState;
        }));
  var nextBidAmount = match !== undefined && (match === "CurrentBid" || match === "ReserveNotMet" || match === "MaxBid" || match === "Absentee") ? Caml_format.int_of_string(Belt_Option.getWithDefault(bidAsk, "0")) - myBidOnLot | 0 : Caml_format.int_of_string(Belt_Option.getWithDefault(bidAsk, "0"));
  return (nextBidAmount + Caml_format.int_of_string(bidCap.amountInUse) | 0) > Caml_format.int_of_string(bidCap.amount);
}

export {
  isBidCapReached ,
}
/* No side effect */
